<template>
    <div class="pix-payment-form p-3">
        <!-- Desktop -->
        <div class="row d-none d-md-flex">
            <div class="col-9 d-flex align-items-center">
                <div class="row d-flex justify-content-center">
                    <div class="col-9">
                        <div class="row mb-2">
                            <div class="col-1 d-flex flex-column justify-content-center">
                                <hr class="m-0">
                            </div>
                            <div class="col-2 d-flex justify-content-center">
                                <div class="item-icon">1</div>
                            </div>
                            <div class="col-2 d-flex flex-column justify-content-center">
                                <hr class="m-0">
                            </div>
                            <div class="col-2 d-flex justify-content-center">
                                <div class="item-icon">2</div>
                            </div>
                            <div class="col-2 d-flex flex-column justify-content-center">
                                <hr class="m-0">
                            </div>
                            <div class="col-2 d-flex justify-content-center">
                                <div class="item-icon">3</div>
                            </div>
                            <div class="col-1 d-flex flex-column justify-content-center">
                                <hr class="m-0">
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-4 text-align-center">
                                Abra o aplicativo do seu banco e escolha a opção PIX
                            </div>
                            <div class="col-4 text-align-center">
                                Copie e cole o código ou use a câmera do celular para ler o QR Code
                            </div>
                            <div class="col-4 text-align-center">
                                Verifique as informações e finalize o pagamento pelo aplicativo do banco
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div v-if="pix.code != ''" class="col-3">
                <div class="code">
                    <qr-code :value="pix.code"></qr-code>
                </div>
                <div class="row">
                    <div class="col-6">
                        <button @click="close()" class="btn btn-dark btn-block"> VOLTAR </button>
                    </div>
                    <div class="col-6">
                        <button class="btn btn-primary btn-block" @click="copy"> {{ copyText }} </button>
                    </div>
                </div>
            </div>
            <div v-else class="col-3 d-flex flex-column justify-content-end">
                <div class="row">
                    <div class="col-6">
                        <button @click="close()" id="generateButton" class="btn btn-dark btn-block"> Voltar </button>
                    </div>
                    <div class="col-6">
                        <button @click="submit()" id="generateButton" class="btn btn-primary btn-block"> Gerar PIX </button>
                    </div>
                </div>
            </div>
        </div>
        <!-- Mobile -->
        <div class="row d-flex d-md-none">
            <div class="col-12">
                <div class="row d-flex justify-content-center">
                    <div class="col-4 d-flex flex-column justify-content-center">
                        <hr class="m-0">
                    </div>
                    <div class="col-4 d-flex justify-content-center">
                        <div class="item-icon">1</div>
                    </div>
                    <div class="col-4 d-flex flex-column justify-content-center">
                        <hr class="m-0">
                    </div>
                </div>
                <div class="row text-align-center my-3">
                    <div class="col-12">
                        Abra o aplicativo do seu banco e escolha a opção PIX
                    </div>
                </div>
                <div class="row d-flex justify-content-center">
                    <div class="col-4 d-flex flex-column justify-content-center">
                        <hr class="m-0">
                    </div>
                    <div class="col-4 d-flex justify-content-center">
                        <div class="item-icon">2</div>
                    </div>
                    <div class="col-4 d-flex flex-column justify-content-center">
                        <hr class="m-0">
                    </div>
                </div>
                <div class="row text-align-center my-3">
                    <div class="col-12">
                        Copie e cole o código ou use a câmera do celular para ler o QR Code
                    </div>
                </div>
                <div class="row d-flex justify-content-center">
                    <div class="col-4 d-flex flex-column justify-content-center">
                        <hr class="m-0">
                    </div>
                    <div class="col-4 d-flex justify-content-center">
                        <div class="item-icon">3</div>
                    </div>
                    <div class="col-4 d-flex flex-column justify-content-center">
                        <hr class="m-0">
                    </div>
                </div>
                <div class="row text-align-center my-3">
                    <div class="col-12">
                        Verifique as informações e finalize o pagamento pelo aplicativo do banco
                    </div>
                </div>
            </div>
            <div v-if="pix.code != ''" class="col-12">
                <div class="code d-flex justify-content-center">
                    <qr-code :value="pix.code"></qr-code>
                </div>
                <div class="row">
                    <div class="col-6">
                        <button @click="close()" class="btn btn-dark btn-block"> VOLTAR </button>
                    </div>
                    <div class="col-6">
                        <button class="btn btn-primary btn-block" @click="copy"> {{ copyText }} </button>
                    </div>
                </div>
            </div>
            <div v-else class="col-12 d-flex flex-column justify-content-end">
                <div class="row">
                    <div class="col-6">
                        <button @click="close()" id="generateButton" class="btn btn-dark btn-block" :disabled="loading"> VOLTAR </button>
                    </div>
                    <div class="col-6">
                        <button v-if="!loading" @click="submit()" id="generateButton" class="btn btn-primary btn-block"> GERAR PIX </button>
                        <button v-else class="form-control btn-disabled d-flex justify-content-center align-items-center" type="button" disabled>
                            <div class="spinner-border text-dark" role="status"></div>
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Vue from 'vue'
import QrCode from '../../utils/qrcode.vue'

export default Vue.extend({
    data() {
        return {
            blur: true,
            copyText: 'Copiar'
        }
    },
    components: {
        QrCode
    },
    props: {
        pix: {
            default() {
                return {
                    code: '',
                    expiration: null,
                }
            },
            type: Object
        },
        loading: {}
    },
    methods: {
        generate() {
            this.blur = false
            this.value = '123123178231'
        },
        close() {
            this.$emit('close')
        },
        submit() {
            this.$emit('submit')
        },
        copy() {
            window.navigator.clipboard.writeText(this.pix.code)
            this.copyText = 'Copiado!'
            setTimeout(() => this.copyText = 'Copiar', 5000)
        }
    }
})
</script>

<style scoped>
    .pix-payment-form {
        border: 1px solid #d5d6d7;
        border-radius: 4px;
    }

    .blur {
        filter: blur(2px);
    }

    ol {
        padding-left: 1rem;
        margin-bottom: 0;
    }
    
    .text-align-center {
        text-align: center;
    }
</style>